<template>
  <div>
    <div v-if="showModal" class="overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none justify-center items-center flex">
      <div class="relative w-auto my-6 mx-auto max-w-3xl">
        <!--content-->
        <div class="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">
          <!--header-->
          <div class="flex items-start justify-between p-5 border-b border-solid border-blueGray-200 rounded-t">
            <h3 class="text-3xl font-semibold">
              {{ pageType }} Client 
            </h3>
            <button class="p-1 ml-auto bg-transparent border-0 text-black opacity-5 float-right text-3xl leading-none font-semibold outline-none focus:outline-none" v-on:click="toggleModal()">
              <span class="bg-transparent text-black opacity-5 h-6 w-6 text-2xl block outline-none focus:outline-none">
                ×
              </span>
            </button>
          </div>
          <!--body-->
          <div class="relative p-6 flex-auto">
            <div class="flex-auto px-0 lg:px-0 py-0 pt-0">
              <div class="w-full lg:w-12/12 px-0"  v-if="alertType != ''">
                <div 
                class="text-white px-4 py-2 border-0 rounded relative mb-4"
                v-bind:class="{'bg-emerald-500': alertType == 'Success', 'bg-red-500': alertType == 'Failed'}">
                  <span class="text-m inline-block mr-5 align-middle">
                    <i class="fas fa-bell"></i>
                  </span>
                  <span class="inline-block align-middle mr-8">
                    <b class="capitalize">{{ alertType }}!</b> {{ alertMessage }}
                  </span>
                  <button class="absolute bg-transparent text-2xl font-semibold leading-none right-0 top-0 mt-2 mr-6 outline-none focus:outline-none">
                    <span>×</span>
                  </button>
                </div>
              </div>
              <div class="flex flex-wrap">
                <div class="w-full lg:w-6/12 px-4">
                  <div class="relative w-full mb-3">
                    <label
                      class="block uppercase text-blueGray-600 text-xs font-bold mb-2"
                      htmlFor="grid-password"
                    >
                      Client Name 
                    </label>
                    <input
                      type="text"
                      v-model="client.client_name"
                      name="client_name"

                      class="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                      
                    />
                  </div>
                </div>
                <div class="w-full lg:w-6/12 px-4">
                  <div class="relative w-full mb-3">
                    
                  </div>
                </div>
                <div class="w-full lg:w-6/12 px-4">
                  <div class="relative w-full mb-3">
                    <label
                      class="block uppercase text-blueGray-600 text-xs font-bold mb-2"
                      htmlFor="grid-password"
                    >
                      Auth Token (ENCRYPTED)
                    </label>
                    <div class="relative flex w-full flex-wrap items-stretch mb-3">
                      <span class="z-10 h-full leading-normal font-bold absolute text-center absolute bg-transparent rounded text-sm items-center justify-center w-30 pl-3 py-3">
                        Bearer
                      </span>
                      <input 
                      type="text" 
                      v-model="client.auth_token"
                      name="auth_token"
                      placeholder="Input Bearer Token" 
                      class="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 relative bg-white bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150 w-full pl-13"/>
                    </div>  
                  </div>
                </div>
                <div class="w-full lg:w-6/12 px-4">
                  <div class="relative w-full mb-3">
                    <button
                    class="bg-paxel-700 text-white active:bg-paxel-900 font-bold uppercase text-xs px-4 py-2 mt-7 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150"
                    type="button"
                    @click="generateToken"
                    >Generate</button>
                  </div>
                </div>
              </div>
            </div>          
          </div>  
          <!--footer-->
          <div class="flex items-center justify-end p-6 border-t border-solid border-blueGray-200 rounded-b">
            <button class="text-red-500 background-transparent font-bold uppercase px-6 py-2 text-sm outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150" type="button" v-on:click="toggleModal()">
              Close
            </button>
            <button class="bg-emerald-500 text-white active:bg-emerald-600 font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150" type="button" 
            v-on:click="onSubmit(this.client)">
              Save Changes
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

  export default {
    data() {
      return {
        client: this.clientProps
      };
    },
    props: {
      pageType: String,
      onSubmit: {type: Function},
      alertType: String,
      alertMessage: String,
      showModal: Boolean,
      toggleModal: {type: Function},
      clientProps: {type: Object}    
    },
    watch: { 
      clientProps: function(newVal, oldVal) { // watch it
        console.log('Prop changed: ', newVal, ' | was: ', oldVal)
        this.client = newVal
      }
    },
    methods: {
      generateToken(){
        var result           = '';
        var characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        var charactersLength = characters.length;
        for ( var i = 0; i < 32; i++ ) {
            result += characters.charAt(Math.floor(Math.random() * charactersLength));
        }
        

        this.client['auth_token'] = result
      }
    }
  }
</script>